(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[79530],{

/***/ 30877:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.e = function BsThreeDots (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 16 16","fill":"currentColor"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 9.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z","clipRule":"evenodd"}}]})(props);
};


/***/ }),

/***/ 15787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "fa",
    "name": "Font Awesome",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/refactoringui/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}

function GenIcon(data) {
  return function (props) {
    return react.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
        size = props.size,
        title = props.title,
        svgProps = __rest(props, ["attr", "size", "title"]);

    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + ' ' : '') + props.className;
    return react.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react.createElement("title", null, title), props.children);
  };

  return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/index.js




/***/ }),

/***/ 79530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Index_ShortTerms; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Index/ShortTerms.module.css
var ShortTerms_module = __webpack_require__(63964);
var ShortTerms_module_default = /*#__PURE__*/__webpack_require__.n(ShortTerms_module);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/bs/BsThreeDots.js
var BsThreeDots = __webpack_require__(30877);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/TermItem.module.css
var TermItem_module = __webpack_require__(79639);
var TermItem_module_default = /*#__PURE__*/__webpack_require__.n(TermItem_module);
// EXTERNAL MODULE: ./context/TranslationContext.js
var TranslationContext = __webpack_require__(73040);
;// CONCATENATED MODULE: ./components/TermItem.js





var TermItem = function(param) {
    var data = param.data;
    var nights = (0,TranslationContext/* useTranslation */.m)().nights;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex-none px-2 lg:py-2 w-44 sm:w-5/12 lg:w-4/12 xl:w-1/6 first:pl-0 last:pr-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bg-kisasureli-bg rounded-md py-5 px-4 flex flex-col transform transition-shadow hover:shadow-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "bg-white rounded-sm text-black text-15 text-center p-3 font-medium",
                    children: data.ay
                }),
                data.deger.map(function(day, dayindex) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: day.url,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            title: day.title,
                            className: "mt-3 flex justify-between text-13 items-center ml-1 group " + (TermItem_module_default()).ShortTermDay,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "text-brand-black-2 font-bold",
                                    children: [
                                        day.gece,
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-normal lg:ml-3",
                                            children: nights
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-white bg-kisasureli-count-bg bg-transparent transform transition-all duration-200 group-hover:bg-none group-hover:text-brand-orange-2 rounded-2xl w-14 text-13 text-center py-1 group-hover:bg-white",
                                    children: day.adet
                                })
                            ]
                        })
                    }, dayindex);
                })
            ]
        })
    });
};
/* harmony default export */ var components_TermItem = (TermItem);

// EXTERNAL MODULE: ./components/api.js
var api = __webpack_require__(9012);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(84849);
;// CONCATENATED MODULE: ./components/Index/ShortTerms.js









var ShortTerms = function(param) {
    var hideTitle = param.hideTitle;
    var ref = (0,TranslationContext/* useTranslation */.m)(), shortTermsTitle = ref.shortTermsTitle, all = ref.all;
    var ref1 = (0,react.useState)([]), data = ref1[0], setData = ref1[1];
    var ref2 = (0,react.useState)(false), page = ref2[0], setPage = ref2[1];
    (0,react.useEffect)(function() {
        (0,api/* HomeShortTerms */.Hz)().then(function(result) {
            setData(result.data.data);
            setPage(result.data.page);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (hideTitle ? (ShortTerms_module_default()).HideTitle : "mt-12 lg:mt-36 pb-24") + " relative " + (ShortTerms_module_default()).ShortTermsBg,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container flex flex-col lg:items-center gap-y-6 lg:gap-y-0",
            children: [
                !hideTitle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "font-bold text-xl lg:text-3xl text-brand-black lg:text-orange lg:leading-69 lg:mb-10",
                            children: shortTermsTitle
                        }),
                        page && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: page.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                title: page.title,
                                className: "text-brand-black font-bold text-13 lg:hidden self-end",
                                children: [
                                    all,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BsThreeDots/* BsThreeDots */.e, {
                                        size: "36",
                                        className: "inline-block text-brand-blue"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex w-full overflow-x-auto lg:flex-wrap pb-5 lg:pb-0",
                    children: data.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-none px-2 lg:py-2 w-44 sm:w-5/12 lg:w-4/12 xl:w-1/6 first:pl-0 last:pr-0 h-[300px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    className: "w-full h-full"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-none px-2 lg:py-2 w-44 sm:w-5/12 lg:w-4/12 xl:w-1/6 first:pl-0 last:pr-0 h-[300px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    className: "w-full h-full"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-none px-2 lg:py-2 w-44 sm:w-5/12 lg:w-4/12 xl:w-1/6 first:pl-0 last:pr-0 h-[300px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    className: "w-full h-full"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-none px-2 lg:py-2 w-44 sm:w-5/12 lg:w-4/12 xl:w-1/6 first:pl-0 last:pr-0 h-[300px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    className: "w-full h-full"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-none px-2 lg:py-2 w-44 sm:w-5/12 lg:w-4/12 xl:w-1/6 first:pl-0 last:pr-0 h-[300px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    className: "w-full h-full"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-none px-2 lg:py-2 w-44 sm:w-5/12 lg:w-4/12 xl:w-1/6 first:pl-0 last:pr-0 h-[300px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    className: "w-full h-full"
                                })
                            })
                        ]
                    }) : data.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TermItem, {
                            data: item
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Index_ShortTerms = (ShortTerms);


/***/ }),

/***/ 63964:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ShortTermsBg":"ShortTerms_ShortTermsBg__xQAFU","HideTitle":"ShortTerms_HideTitle__pOfYX"};

/***/ }),

/***/ 79639:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ShortTermDay":"TermItem_ShortTermDay__pWB82"};

/***/ })

}]);